/* eslint-disable no-console */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-redeclare */
/* eslint-disable react/style-prop-object */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { QRCode } from 'react-qr-svg';
import { toast } from 'react-toastify';
import { io, Socket } from 'socket.io-client';
import { callNurseApi, trueApi } from '../../services/api';
import { messages } from '../../utils/statusMessage';
import {
  dateHourToString,
  dateHourToStringFormatted,
  dateToStringFormatted,
} from '../../utils/dateConversion';
import { capitalizeString } from '../../utils/stringFormat';
import { Select } from '../../components/Select';
import { Input } from '../../components/Input';
import { ProductInformation } from '../../components/ProductInformation';
import { Button } from '../../components/Button';
import { Title } from '../../components/Title';
import { Status } from '../../components/Table/Status';
import { ModalConfirmation } from '../../components/ModalConfimation';
import { ContainerWrapper } from '../../components/Input/styles';
import { Content } from './styles';
import Expandable from '../../components/ExpandableContainer';
import Chat from '../../components/Chat';
import CallConteudo from '../../components/CallConteudo';
import CallMessage from '../../components/CallMessage';
import Door from '../../assets/Vector.png';
import Cam from '../../assets/Vector.svg';
import info from '../../assets/info.svg';
import InputMessage from '../../components/InputChat';
import InputEnviar from '../../components/textBox';
import Video from '../../components/Video';
import { ModalHistoric } from '../../components/historicModal';
import Info from '../../components/info/info';

const statusValue: { [key: number]: string } = {
  0: 'Aguardando',
  1: 'Em atendimento',
  2: 'Finalizado',
};

export interface Data {
  cdAtendimento: number;
  cdAtendente: number;
  nomeNivelCriticidade: string; //
  dataAbertura: string; //
  statusAtendimento: string; //
  cdStatusAtendimento: string;
  cnpjCliente: string; //
  nomeAtendente: string;
  nomeGrupo: string;
  nomeCliente: string;
  cdCliente: number;
  IdInterno: number;
  Chat: IMensagem[];
  Historico: Data[];
}

export interface IMensagem {
  nomeRemetente: string;
  conteudo: string;
  dataEnvio: Date;
  cdAtendimento: number;
}

interface ISocketVideoMessage {
  offer: string;
  cdUsuario?: number;
  cdCliente?: number;
}

export function RequestForm() {
  const { id } = useParams();
  const formRef = useRef<FormHandles>(null);

  const [requestData, setRequestData] = useState<Data>({} as Data);
  const [mensagemLocal, setMensagemLocal] = useState('');
  const [showInfo, setShowInfo] = useState(false);
  const [receivedCall, setReceivedCall] = useState<string | null>(null);
  const [cdAtendimentoModal, setCdAtendimentoModal] = useState<number | null>(null);
  const [socket, setSocket] = useState<Socket>();

  const [showVideo, setShowVideo] = useState(false);

  function OpenInfo() {
    setShowInfo(true);
  }

  function OpenVideo() {
    setShowVideo(true);
  }

  function CloseVideo() {
    setShowVideo(false);
  }

  async function FinalizarChamada(cdAtendimento: string | undefined) {
    try {
      if (requestData?.cdStatusAtendimento === 'F') {
        toast.error('Erro ao finalizar atendimento: Atendimento já finalizado!');
      } else {
        const response = await callNurseApi.put('/atendimento/end', {
          cdAtendimento,
          cdUsuario: -1,
          cdCliente: null,
        });

        if (response?.data.status) {
          toast.success('Atendimento finalizado com sucesso!');
        } else {
          toast.error('Erro ao finalizar atendimento!');
        }
      }
    } catch {
      toast.error('Erro ao buscar dados');
    }
  }

  async function MensagemFinalizada(cdAtendimento: string | undefined) {
    try {
      const response = await callNurseApi.post('/mensagem/select', {
        cdAtendimento,
        pageCount: 500,
        pageNumber: 1,
      });
      if (response.data.status) {
        setRequestData((oldRequestData: Data) =>
          ({ ...oldRequestData, Chat: response.data.messages }));
      }
    } catch {
      toast.error('Erro ao buscar dados');
    }
  }

  async function BuscarHistorico(cdCliente: number) {
    try {
      const response = await callNurseApi.post('/atendimento/pageSelect', {
        empresaCliente: cdCliente,
        pageCount: 500,
        pageNumber: 1,
      });
      setRequestData((oldRequestData) => {
        const newHistory = [
          ...(oldRequestData.Historico || []),
          ...(response?.data?.atendimentos || []),
        ];
        return { ...oldRequestData, Historico: newHistory };
      });
    } catch {
      toast.error('Erro ao buscar dados');
    }
  }

  async function BuscarAtendimentoInfo(cdAtendimento: string | undefined) {
    try {
      const response = await callNurseApi.get(
        `/atendimento/?cdAtendimento=${cdAtendimento}`,
      );
      if (response?.data?.status) {
        setRequestData(response.data.atendimento);
      }
    } catch {
      toast.error('Erro ao buscar dados');
    }
  }

  async function envioMensagem(
    cdAtendimento: string | undefined,
    dataEnvio: Date,
    conteudo: string,
  ) {
    try {
      const response = await callNurseApi.post('/mensagem/send', {
        usuarioRemetente: -1,
        dataEnvio,
        cdAtendimento,
        conteudo,
      });
      console.log(response?.data);

      if (response?.data.status) {
        console.log('mensagem enviada com sucesso');
      }
    } catch {
      toast.error('Erro ao buscar dados');
    }
  }
  function handleSubmit() {
    envioMensagem(id, new Date(), mensagemLocal);
    setMensagemLocal('');
  }

  useEffect(() => {
    const carregarInformacoes = async () => {
      await BuscarAtendimentoInfo(id);
    };
    MensagemFinalizada(id);

    carregarInformacoes();
  }, []);

  useEffect(() => {
    if (requestData.cdCliente) {
      BuscarHistorico(requestData.cdCliente);
    }
  }, [requestData.cdCliente]);

  useEffect(() => {
    if (requestData && !socket) {
      const cartao = io('https://call-nurse-api-rsaxdr7avq-rj.a.run.app', {});
      // const cartao = io('http://192.168.1.84:3001');
      setSocket(cartao);
    }
  }, [requestData]);

  useEffect(() => {
    if (!socket || !requestData) {
      return;
    }
    socket.on('message', (msg) => {
      console.log(`Mensagem recebida ${msg}`);
      console.log(msg);

      // ADICIONAR NO NOSSO CHAT
      setRequestData((oldRequestData) => {
        const newChat = [...(oldRequestData.Chat || []), msg];
        return { ...oldRequestData, Chat: newChat };
      });
    });
    // socket.on('queue change', (atendimentos) => atendimento.posicao);
    // atendimentos.foreach(atendimento => console.log(atendimento));
    socket.on('end service', ({ cdCliente, cdUsuario }) => {
      if (cdCliente) {
        toast('Atendimento finalizado pelo cliente');
      }
      BuscarAtendimentoInfo(id);
    });
    socket.emit('enter room', id);

    let socketMessage: ISocketVideoMessage = {} as ISocketVideoMessage;

    socket.on('video call request', (msg) => {
      console.log({ msg });
      socketMessage = msg;
      if (socketMessage.cdUsuario !== -1) {
        console.log(socketMessage.offer);
        setReceivedCall(socketMessage.offer);
      }
    });
  }, [socket]);

  return (
    <>
      <Title title="Atendimento" backButton />
      <Content>
        <div id="chatBox">
          <div id="chatContent">
            <div id="tableChat">
              <div id="chatHeader">
                <div id="info">
                  <button type="button" onClick={() => OpenInfo()}>
                    <img
                      src={info}
                      id="info"
                      alt="Info"
                    />
                  </button>
                </div>
                <h3 id="nameChat">{requestData?.nomeCliente}</h3>
                <div id="icons">
                  <button type="button">
                    <img
                      src={Door}
                      onClick={() => {
                        FinalizarChamada(id);
                      }}
                      id="door"
                      alt="Sair"
                    />
                  </button>
                  <button id={receivedCall ? 'receivingCall' : 'receivingCall'} type="button" onClick={() => OpenVideo()}>
                    <img src={Cam} id="cam" alt="Iniciar Chamada de Vídeo" />
                    {
                      receivedCall &&
                      <div id="callDot" />
                    }
                  </button>
                </div>
              </div>
              {showVideo && (
              <Video
                CloseVideo={CloseVideo}
                requestData={requestData}
                socket={socket}
                receivedCall={receivedCall}
              />
              )}
              <ModalHistoric
                cdAtendimentoModal={cdAtendimentoModal}
                setCdAtendimentoModal={setCdAtendimentoModal}
              />
              <CallMessage chat={requestData?.Chat || []} />
            </div>
            <div id="tableHistorico">
              <div id="historicoHeader">
                <h3 id="nameHistorico">Histórico</h3>
              </div>
              {requestData.Historico &&
                requestData.Historico.map((atendimento) => (
                  <CallConteudo
                    cdAtendimento={atendimento.cdAtendimento}
                    dataCriacao={atendimento.dataAbertura}
                    setCdAtendimentoModal={setCdAtendimentoModal}
                  />
                ))}
            </div>
          </div>
          {requestData?.cdStatusAtendimento === 'A' && (
            <InputEnviar
              nome={mensagemLocal}
              setMensagemLocal={setMensagemLocal}
              envioMensagem={handleSubmit}
            />
          )}

          <div />
        </div>
      </Content>
    </>
  );
}
